function NXSearch({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4294_1322)">
        <path
          d="M8.57143 16.4286C12.9108 16.4286 16.4286 12.9108 16.4286 8.57144C16.4286 4.23205 12.9108 0.714294 8.57143 0.714294C4.23204 0.714294 0.714287 4.23205 0.714287 8.57144C0.714287 12.9108 4.23204 16.4286 8.57143 16.4286Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.2857 19.2857L14.2857 14.2857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4294_1322">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXSearch;
